// extracted by mini-css-extract-plugin
module.exports = {"homeMainContent":"home_homeMainContent__I1tBb","bannerContent":"home_bannerContent__jgvbk"};